/**
 * OEAMTC advent calendar base js module
 */

// app module
require(['main'], function (main) {
    "use strict";

    require(['jquery', 'bootstrap'], function ($) {

        main.log('initializing adventkalender app module ...');

        var isSubmit = false;
        var $oeamtcLogin = document.getElementsByTagName('oeamtc-login').item(0);
        var $userInfo = $("#user-info");
        var $participate = $("#participate");

        // Responsive menu
        $("#navbar-toggle").click(function () {
            var $btn = $(this);

            if ($btn.hasClass("collapsed")) {
                // hide user menu if collapsed
                if ($userInfo.hasClass("in")) {
                    $userInfo.collapse('hide');
                    $("#user-info-toggle").addClass('collapsed');
                }
                // show menu
                $("#navbar-main-collapse").collapse('show');
            } else {
                $("#navbar-main-collapse").collapse('hide');
            }
            $btn.toggleClass("collapsed");
        });

        // Responsive user menu
        $("#user-info-toggle").click(function () {
            var $btn = $(this);

            if ($btn.hasClass("collapsed")) {
                // hide menu if collapsed
                var $navbarMainCollapse = $("#navbar-main-collapse");
                if ($navbarMainCollapse.hasClass("in")) {
                    $navbarMainCollapse.collapse('hide');
                    $("#navbar-toggle").addClass('collapsed');
                }
                // show user menu
                $userInfo.collapse('show');
            } else {
                $userInfo.collapse('hide');
            }
            $btn.toggleClass("collapsed");
        });

        // AGBs accepted
        $participate.submit(function (event) {
            if (!$("#agb").is(":checked")) {
                $("#errorMessageBox").modal('show');
                event.preventDefault();
                return false;
            }
            if ($oeamtcLogin && !window.gewinnspiel.isLoggedIn) {
                isSubmit = true;
                $(window).scrollTop(0);
                $oeamtcLogin.setAttribute('display-component', JSON.stringify(true));
                event.preventDefault();
                return false;
            }
        });

        // Message box
        var $messageBox = $('#messageBox');
        if ($messageBox.data('hidden') !== true) {
            $messageBox.modal('show');
        }

        // login success event
        if ($oeamtcLogin) {
            $oeamtcLogin.addEventListener('login-success', function (event) {
                if (event.detail) {
                    if (isSubmit) {
                        isSubmit = false;
                        // disable submit event handlers
                        $participate.off('submit');
                        // perform submit
                        $participate.submit();
                    }
                }
            });
        }
    });
});
define("adventkalender", function(){});

